import { cn } from "@/lib/utils";

export interface SimpleLoaderProps {
  /**
   * The number of bouncing dots to display.
   * @default 5
   */
  bars?: number;
  /**
   * Optional message to display alongside the bouncing dots.
   */
  message?: string;
  /**
   * Position of the message relative to the spinner.
   * @default bottom
   */
  messagePlacement?: "bottom" | "left" | "right";
  className?: string;
}

export function SimpleLoader({
  bars = 5,
  message,
  messagePlacement = "bottom",
  className,
}: SimpleLoaderProps) {
  const containerClass = cn(
    "flex gap-2 items-center justify-center",
    {
      "flex-col": messagePlacement === "bottom",
      "flex-row": messagePlacement === "right",
      "flex-row-reverse": messagePlacement === "left",
    }
  );

  return (
    <div className={containerClass}>
      <div className="flex gap-1 items-center justify-center">
        {Array(bars)
          .fill(undefined)
          .map((_, index) => (
            <div
              key={index}
              className={cn(
                "w-2 h-5 bg-foreground origin-bottom animate-bounce",
                className
              )}
              style={{
                animationDelay: `${index * 0.1}s`,
                animationDuration: "1s",
                animationIterationCount: "infinite",
              }}
            />
          ))}
      </div>
      {message && <div>{message}</div>}
    </div>
  );
}
